<template>
  <v-container class="py-12">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Programações Preventivas</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn color="primary" elevation="0" to="/manutencoes/programacoes/novo">
              <v-icon left small>mdi-plus</v-icon>
              Nova programação
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="applyFilter">
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    dense outlined hide-details
                    label="Nome"
                    v-model="filters.name"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    dense outlined hide-details
                    label="Gatilho"
                    :items="resources.triggerTypes"
                    item-text="label"
                    item-value="value"
                    v-model="filters.trigger_type"
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    dense outlined hide-details
                    label="Status"
                    :items="activeOptions"
                    item-text="label"
                    item-value="value"
                    v-model="filters.active"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Aplicar filtros</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabela -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :server-items-length="total"
            :items-per-page="pagination.limit"
            @update:page="onPage"
            @update:items-per-page="onLimit"
            :footer-props="footerProps"
            no-data-text="Nenhuma programação encontrada"
            loading-text="Carregando..."
            class="app-table hover-table"
          >
            <template v-slot:[`item.maintenance_type`]="{ item }">
              {{ maintenanceTypeLabel(item.maintenance_type) }}
            </template>
            <template v-slot:[`item.trigger_type`]="{ item }">
              <v-chip x-small outlined :color="getTriggerColor(item.trigger_type)">
                {{ getTriggerLabel(item.trigger_type) }}
              </v-chip>
            </template>
            <template v-slot:[`item.interval`]="{ item }">
              <span class="font-weight-medium">{{ item.interval_value }}</span>
              <span class="caption grey--text ml-1">{{ formatUnit(item.interval_unit) }}</span>
            </template>
            <template v-slot:[`item.active`]="{ item }">
              <v-chip x-small :color="item.active ? 'green' : 'grey'" dark>
                {{ item.active ? 'Ativa' : 'Inativa' }}
              </v-chip>
            </template>
            <template v-slot:[`item.vehicles_count`]="{ item }">
              <v-chip x-small outlined>
                <v-icon x-small left>mdi-car-outline</v-icon>
                {{ Number(item.vehicles_count) || 0 }}
              </v-chip>
              <div class="caption grey--text mt-1">
                {{ scopeLabel(item.scope) }}<span v-if="Number(item.model_rules_count)"> · {{ item.model_rules_count }} regra(s) por modelo</span>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="$router.push('/manutencoes/programacoes/' + item.id)">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="remove(item)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PreventiveSchedulingList',
  data: () => ({
    breadcrumbs: [
      { text: 'Home', to: '/home', disabled: false, exact: true },
      { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
      { text: 'Programações', disabled: true, exact: true },
    ],
    headers: [
      { text: 'Nome', value: 'name' },
      { text: 'Tipo', value: 'maintenance_type' },
      { text: 'Gatilho', value: 'trigger_type' },
      { text: 'Intervalo', value: 'interval' },
      { text: 'Status', value: 'active' },
      { text: 'Veículos', value: 'vehicles_count' },
      { text: 'Ações', value: 'actions', sortable: false, width: '100px' },
    ],
    footerProps: {
      itemsPerPageText: 'Itens por página:',
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      pageText: '{0}-{1} de {2}',
    },
    activeOptions: [
      { label: 'Todos', value: null },
      { label: 'Ativos', value: true },
      { label: 'Inativos', value: false },
    ],
    items: [],
    total: 0,
    loading: false,
    pagination: { page: 1, limit: 10 },
    filters: { name: '', trigger_type: null, active: null },
    resources: {
      maintenanceTypes: [],
      triggerTypes: [],
    },
  }),
  created() {
    this.loadResources()
    this.load()
  },
  methods: {
    maintenanceTypeLabel(value) {
      const item = (this.resources.maintenanceTypes || []).find((t) => t.value === value)
      return item?.label || value
    },
    scopeLabel(scope) {
      const map = { all: 'Todos os veículos', models: 'Por modelo', manual: 'Veículos escolhidos' }
      return map[scope] || map.manual
    },
    formatUnit(unit) {
      const map = { km: 'KM', mi: 'MI', hours: 'horas', days: 'dias' }
      return map[unit] || unit || '-'
    },
    getTriggerColor(type) {
      const map = { odometer: 'blue', hour_meter: 'purple', time: 'teal', manual: 'grey' }
      return map[type] || 'grey'
    },
    getTriggerLabel(type) {
      const map = { odometer: 'Hodômetro', hour_meter: 'Horímetro', time: 'Tempo', manual: 'Manual' }
      return map[type] || type
    },
    notifyError(message) {
      if (this.$dialog?.notify) {
        this.$dialog.notify.error(message, { position: 'top-right', timeout: 5000 })
      }
    },
    notifySuccess(message) {
      if (this.$dialog?.notify) {
        this.$dialog.notify.success(message, { position: 'top-right', timeout: 4000 })
      }
    },
    applyFilter() {
      this.pagination.page = 1
      this.load()
    },
    async loadResources() {
      try {
        const { data } = await axios.get('/api/v2/maintenance/schedulings/resources')
        this.resources = data?.content || this.resources
      } catch (error) {
        this.notifyError(this.$codes ? this.$codes(error) : 'Erro ao carregar recursos.')
      }
    },
    buildSearch() {
      const search = {}
      if (this.filters.name) search.name = this.filters.name
      if (this.filters.trigger_type) search.trigger_type = this.filters.trigger_type
      if (this.filters.active !== null) search.active = this.filters.active
      return search
    },
    async load() {
      this.loading = true
      try {
        const search = this.buildSearch()
        const { data } = await axios.get('/api/v2/maintenance/schedulings', {
          params: {
            page: this.pagination.page,
            limit: this.pagination.limit,
            search: Object.keys(search).length ? JSON.stringify(search) : undefined,
          },
        })

        const content = data?.content || {}
        this.items = content.data || []
        this.total = content.total || 0
      } catch (error) {
        this.notifyError(this.$codes ? this.$codes(error) : 'Erro ao carregar programações.')
      } finally {
        this.loading = false
      }
    },
    onPage(page) {
      this.pagination.page = page
      this.load()
    },
    onLimit(limit) {
      this.pagination.limit = limit
      this.pagination.page = 1
      this.load()
    },
    async remove(item) {
      if (!window.confirm('Deseja realmente remover esta programação?')) return

      try {
        await axios.delete(`/api/v2/maintenance/schedulings/${item.id}`)
        this.notifySuccess('Programação removida.')
        this.load()
      } catch (error) {
        this.notifyError(this.$codes ? this.$codes(error) : 'Erro ao remover programação.')
      }
    },
  },
}
</script>
